import React, { useState, useContext } from 'react';
import { Modal, Button, message } from 'antd';
import { deleteTemplate } from '../../utils/services/templatesAPI';
import { deleteShortMessageTemplate } from '../../utils/services/shortMessageTemplateAPI';
import { deleteMailTemplate } from '../../utils/services/mailTemplateAPI';
import { deleteBlockElement, deleteEmailElement, deleteFlowElement } from '../../utils/services/elementAPI';
import { ModalBody, Container } from './styles';
import { DESIGN_AREA_TEMPLATES_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';
import { deleteStandaloneFlow} from '../../utils/services/complexDocumentsAPI';
import { deleteComplexMailTemplate ,deleteReferencedBlock} from '../../utils/services/complexEmailAPI';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';

const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB'];
const DeleteTemplateModal = props => {
  const { visible, onCancel, targetTemplate, onSucess, isMailTemplate,
    isElement, categoryType, isShortMessageTemplate, activeContent, TemplateType, complexEmailTemplate } = props;
    const { t } = useTranslation(NAMESPACES);
  const [deleting, setDeleting] = useState(false);
  const { updateCategoryTemplates } = useContext(AppStoreContext);

  const onDelete = () => {
    const payload = {
      id: targetTemplate.id || targetTemplate.parentBlockId,
    };
    if (isElement) {
      deleteRefElements(payload)
    } else if(isShortMessageTemplate){
      deleteShortMessageTemplates(payload)
    } else if (TemplateType === 'flow') {
      deleteFlowTemplate(payload);
    } else if (TemplateType === 'block') {
      deleteBlockTemplate(payload);
    } else {
      isMailTemplate ? deleteMailTemplates(payload) : deleteCategoryTemplate(payload);
    }
  };

  const deleteFlowTemplate = async(payload) =>{
    const deletionResponse = await deleteStandaloneFlow(payload.id);
    if(deletionResponse.statusCode === 2606){
      message.success(
        t(
          DESIGN_AREA_TEMPLATES_TAB.STANDALONE_FLOW_DELETE_SUCCESS_MESSAGE.key,
          DESIGN_AREA_TEMPLATES_TAB.STANDALONE_FLOW_DELETE_SUCCESS_MESSAGE.value,
        ),
      );
      onSucess(true);
    } else {
      message.error(t(
        DESIGN_AREA_TEMPLATES_TAB.STANDALONE_FLOW_DELETE_FAILURE_MESSAGE.key,
        DESIGN_AREA_TEMPLATES_TAB.STANDALONE_FLOW_DELETE_FAILURE_MESSAGE.value,
      ));
      onSucess(false);
    }  
  }

  const deleteBlockTemplate = async(payload) =>{
    const deletionResponse = await deleteBlockElement(payload.id);
    if(deletionResponse.statusCode === 2506){
      message.success(
        t(
          DESIGN_AREA_TEMPLATES_TAB.STANDALONE_BLOCK_DELETE_SUCCESS_MESSAGE.key,
          DESIGN_AREA_TEMPLATES_TAB.STANDALONE_BLOCK_DELETE_SUCCESS_MESSAGE.value,
        ),
      );
      onSucess(true);
    } else {
      message.error(t(
        DESIGN_AREA_TEMPLATES_TAB.STANDALONE_BLOCK_DELETE_FAILURE_MESSAGE.key,
        DESIGN_AREA_TEMPLATES_TAB.STANDALONE_BLOCK_DELETE_FAILURE_MESSAGE.value,
      ));
      onSucess(false);
    }  
  }

  const deleteRefElements = async payload => {
    setDeleting(true);
    let deletionResponse
    if (categoryType === "element" && !isMailTemplate) {
      if (activeContent === 'createFlow')
        deletionResponse = await deleteFlowElement(payload);
      else if (activeContent === 'createBlock')
        deletionResponse = await deleteBlockElement(payload.id);
      else if (activeContent === 'Referenced')
        deletionResponse = await deleteReferencedBlock(payload.id);
    } else {
      deletionResponse = await deleteEmailElement(payload);
    }
    if (deletionResponse && deletionResponse.errors && deletionResponse.errors.length === 0) {
      updateCategoryTemplates(targetTemplate, 'deleteCategoryTemplate');
      if(deletionResponse?.statusCode === 1411){
        message.warn(t(
          DESIGN_AREA_TEMPLATES_TAB.ELEMENT_USED_WARN_MESSAGE.key,
          DESIGN_AREA_TEMPLATES_TAB.ELEMENT_USED_WARN_MESSAGE.value,
        ))
        onSucess(false);
      } else {
        if (deletionResponse.statusCode === 2606) {
          message.success(t(
            DESIGN_AREA_TEMPLATES_TAB.STANDALONE_FLOW_DELETE_SUCCESS_MESSAGE.key,
            DESIGN_AREA_TEMPLATES_TAB.STANDALONE_FLOW_DELETE_SUCCESS_MESSAGE.value,
          ))
        } else if (deletionResponse.statusCode === 2506) {
          message.success(t(
            DESIGN_AREA_TEMPLATES_TAB.STANDALONE_BLOCK_DELETE_SUCCESS_MESSAGE.key,
            DESIGN_AREA_TEMPLATES_TAB.STANDALONE_BLOCK_DELETE_SUCCESS_MESSAGE.value,
          ))
        } else {
          message.success(deletionResponse.status);
        }
        onSucess(true);
      }
      setDeleting(false);
    } else {
      setDeleting(false);
    }
  };

  const deleteCategoryTemplate = async payload => {
    setDeleting(true);
    let deletionResponse = await deleteTemplate(payload);
    if (deletionResponse && deletionResponse.statusCode === 705) {
      updateCategoryTemplates(targetTemplate, 'deleteCategoryTemplate');
      message.success(t(
        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_SUCCESS_MESSAGE.key,
        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_SUCCESS_MESSAGE.value,
      ));
      setDeleting(false);
      onSucess();
    } else {
      setDeleting(false);
    }
  };

  const deleteMailTemplates = async payload => {    
    setDeleting(true);
    let deletionResponse = complexEmailTemplate ? await deleteComplexMailTemplate(payload.id) : await deleteMailTemplate(payload);
    if (deletionResponse && deletionResponse.statusCode === 705 && deletionResponse.errors && deletionResponse.errors.length === 0) {
      message.success(t(
        DESIGN_AREA_TEMPLATES_TAB.EMAIL_DELETE_SUCCESS_MESSAGE.key,
        DESIGN_AREA_TEMPLATES_TAB.EMAIL_DELETE_SUCCESS_MESSAGE.value,
      ));
      setDeleting(false);
      onSucess();
    } else {
      setDeleting(false);
    }
  };

  const deleteShortMessageTemplates = async payload => {
    setDeleting(true);
    let deletionResponse = await deleteShortMessageTemplate(payload);
    if (deletionResponse && deletionResponse.statusCode === 1605 && deletionResponse.errors && deletionResponse.errors.length === 0) {
      message.success(t(
        DESIGN_AREA_TEMPLATES_TAB.SHORT_MESSAGE_DELETE_SUCCESS_MESSAGE.key,
        DESIGN_AREA_TEMPLATES_TAB.SHORT_MESSAGE_DELETE_SUCCESS_MESSAGE.value,
      ));
      setDeleting(false);
      onSucess();
    } else {
      setDeleting(false);
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_CONFIRMATION_TITLE.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_CONFIRMATION_TITLE.value)}
        centered
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(DESIGN_AREA_TEMPLATES_TAB.CANCEL_DELETING_TEMPLATE_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.CANCEL_DELETING_TEMPLATE_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
          {deleting
            ? t(DESIGN_AREA_TEMPLATES_TAB.DELETING_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.DELETING_BUTTON.value)
            : t(DESIGN_AREA_TEMPLATES_TAB.DELETE_TEMPLATE_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.DELETE_TEMPLATE_BUTTON.value)
          }
        </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>
              {t(
                DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_CONFIRMATION.key,
                DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_CONFIRMATION.value,
              )}
            </span>
            {targetTemplate && targetTemplate.name && (
              <span className="text-highlighter">{targetTemplate.name}</span>
            )}
            <span>
              {isElement
                ? t(DESIGN_AREA_TEMPLATES_TAB.DELETE_ELEMENT_NAME.key, DESIGN_AREA_TEMPLATES_TAB.DELETE_ELEMENT_NAME.value)
                : t(
                    DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_NAME.key,
                    DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_NAME.value,
                  )}
            </span>
            {targetTemplate && targetTemplate.categoryName && (
              <span>
                {t(
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_UNDER.key,
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_UNDER.value,
                )}
              </span>
            )}
            {targetTemplate && targetTemplate.categoryName && (
              <span className="text-highlighter">{targetTemplate.categoryName}</span>
            )}
            {targetTemplate && targetTemplate.categoryName && (
              <span>
                {t(
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_CATEGORY.key,
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_CATEGORY.value,
                )}
              </span>
            )}
            <span>?</span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default DeleteTemplateModal;
